'use client'

import type { Card, InAppMessage } from '@braze/web-sdk'
import { createContext } from 'react'

import { BrazeCardLoggers } from '../../types/event-loggers'
import { NullableBrazeStores } from '../../types/store'

import { DEFAULT_STORES } from '../../utils/store'

export type BrazeContextType = {
  cards?: Array<Card> | undefined // TODO: Remove this after refactoring mocking cards in tests
  userExternalId: string | null
  setUserExternalId: (id: string | null) => void
  inAppMessage?: InAppMessage | null // TODO: Remove this after refactoring mocking in-app message in tests
} & BrazeCardLoggers &
  NullableBrazeStores

const defaultBrazeLogFunction = () => Promise.resolve(false)

export const initialBrazeContextValue: BrazeContextType = {
  logCardImpression: defaultBrazeLogFunction,
  logCardClick: defaultBrazeLogFunction,
  logCardDismissal: defaultBrazeLogFunction,
  userExternalId: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUserExternalId: () => {},
  ...DEFAULT_STORES,
}

const BrazeContext = createContext<BrazeContextType>(initialBrazeContextValue)

export default BrazeContext
